import React, { useState, useEffect } from 'react';
import { BellIcon } from '@heroicons/react/24/outline';
import { auth, db } from '../firebase';
import { doc, setDoc, getDoc } from 'firebase/firestore';

function Settings() {
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      console.log('Current user:', auth.currentUser?.uid);
      if (!auth.currentUser) {
        setLoading(false);
        return;
      }
      
      try {
        const settingsDoc = await getDoc(doc(db, 'userSettings', auth.currentUser.uid));
        console.log('Settings document exists:', settingsDoc.exists());
        console.log('Settings data:', settingsDoc.data());
        // Initialize settings if they don't exist
        if (!settingsDoc.exists()) {
          await setDoc(doc(db, 'userSettings', auth.currentUser.uid), {
            notificationsEnabled: true
          });
          setNotificationsEnabled(true);
        } else {
          setNotificationsEnabled(settingsDoc.data().notificationsEnabled || false);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
        // Set to false as a safe default
        setNotificationsEnabled(false);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleNotificationToggle = async () => {
    if (!auth.currentUser || updating) {
      console.log('Toggle blocked:', { isUpdating: updating, hasUser: !!auth.currentUser });
      return;
    }

    const newValue = !notificationsEnabled;
    setUpdating(true);
    console.log('Current user for update:', auth.currentUser.uid);
    console.log('Attempting to update notifications to:', newValue);

    try {
      // Update Firestore first
      await setDoc(doc(db, 'userSettings', auth.currentUser.uid), {
        notificationsEnabled: newValue
      }, { merge: true });
      
      console.log('Successfully updated Firestore');
      console.log('Document path:', `userSettings/${auth.currentUser.uid}`);
      // Only update local state if Firestore update succeeds
      setNotificationsEnabled(newValue);
    } catch (error) {
      console.error('Error updating settings:', error);
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div className="animate-pulse">
        <div className="h-32 bg-gray-200 rounded-lg"></div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="border-b border-gray-100 p-4">
        <h2 className="text-xl font-semibold text-gray-900">Settings</h2>
      </div>
      
      <div className="p-4">
        <div className="space-y-4">
          {/* Notifications Section */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-blue-100 rounded-lg">
                <BellIcon className="h-5 w-5 text-blue-600" />
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-900">Notifications</h3>
                <p className="text-sm text-gray-500">Receive SMS reminders for makeup fasts</p>
              </div>
            </div>
            <button
              onClick={handleNotificationToggle}
              disabled={updating}
              className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                notificationsEnabled ? 'bg-blue-600' : 'bg-gray-200'
              } ${updating ? 'opacity-50 cursor-wait' : ''}`}
              role="switch"
              aria-checked={notificationsEnabled}
            >
              <span
                className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                  notificationsEnabled ? 'translate-x-5' : 'translate-x-0'
                }`}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings; 